import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';

class ReelProjectService {
    async getApprovedSubtitleSources(videoId, languageName = 'English') {
        const headers = getAuthHeaders();
        const apiEndpoint = `${process.env.REACT_APP_API_URL}/api/v3/reels/videos/${videoId}/subtitle-sources`;
        const response = await axios.get(apiEndpoint, {
            headers,
            params: { languageName },
        });
        return response.data || [];
    }

    async getLatestSubtitleSources(videoId, languageName = 'English') {
        const headers = getAuthHeaders();
        const apiEndpoint = `${process.env.REACT_APP_API_URL}/api/v3/reels/videos/${videoId}/latest-subtitle-sources`;
        const response = await axios.get(apiEndpoint, {
            headers,
            params: { languageName },
        });
        return response.data || [];
    }

    async listProjects(videoId) {
        const headers = getAuthHeaders();
        const apiEndpoint = `${process.env.REACT_APP_API_URL}/api/v3/reels/projects`;
        const response = await axios.get(apiEndpoint, {
            headers,
            params: { videoId },
        });
        return response.data || [];
    }

    async getProject(projectId) {
        const headers = getAuthHeaders();
        const apiEndpoint = `${process.env.REACT_APP_API_URL}/api/v3/reels/projects/${projectId}`;
        const response = await axios.get(apiEndpoint, { headers });
        return response.data;
    }

    async createProject(payload) {
        const headers = getAuthHeaders();
        const apiEndpoint = `${process.env.REACT_APP_API_URL}/api/v3/reels/projects`;
        const response = await axios.post(apiEndpoint, payload, { headers });
        return response.data;
    }

    async updateProject(projectId, payload) {
        const headers = getAuthHeaders();
        const apiEndpoint = `${process.env.REACT_APP_API_URL}/api/v3/reels/projects/${projectId}`;
        const response = await axios.put(apiEndpoint, payload, { headers });
        return response.data;
    }

    async deleteProject(projectId) {
        const headers = getAuthHeaders();
        const apiEndpoint = `${process.env.REACT_APP_API_URL}/api/v3/reels/projects/${projectId}`;
        const response = await axios.delete(apiEndpoint, { headers });
        return response.data;
    }

    async renderProject(projectId) {
        const headers = getAuthHeaders();
        const apiEndpoint = `${process.env.REACT_APP_API_URL}/api/v3/reels/projects/${projectId}/render`;
        const response = await axios.post(apiEndpoint, {}, { headers });
        return response.data;
    }

    async getRenderStatus(projectId) {
        const headers = getAuthHeaders();
        const apiEndpoint = `${process.env.REACT_APP_API_URL}/api/v3/reels/projects/${projectId}/render-status`;
        const response = await axios.get(apiEndpoint, { headers });
        return response.data;
    }

    async exportVideo(payload) {
        const headers = getAuthHeaders();
        const apiEndpoint = `${process.env.REACT_APP_API_URL}/api/v3/videos/export`;
        const response = await axios.post(apiEndpoint, payload, { headers });
        return response.data;
    }

    async getExportStatus(jobId) {
        const headers = getAuthHeaders();
        const apiEndpoint = `${process.env.REACT_APP_API_URL}/api/v3/videos/export/status/${jobId}`;
        const response = await axios.get(apiEndpoint, { headers });
        return response.data;
    }

    async getVideoExports(videoId) {
        const headers = getAuthHeaders();
        const apiEndpoint = `${process.env.REACT_APP_API_URL}/api/v3/videos/${videoId}/exports`;
        const response = await axios.get(apiEndpoint, { headers });
        return response.data;
    }
}

const reelProjectServiceInstance = new ReelProjectService();
export default reelProjectServiceInstance;
